import { FormatChange } from '../common';
import { useApiGet } from '../../hooks/useApiGet';

const CurrencyRates = () => {
    const { data, error, loading } = useApiGet('/stocktracker/api/currency-rates');

    if (loading) return <div className="loading-box">Loading currency rate...</div>;
    if (error) return <div className="error-box">Error: {error}</div>;
    if (!data) return <div className="error-box">No market data available</div>;

    return (
        <div className="currency-rates-container">
            <div className="indicator-box">
                <h3>CHF/EUR</h3>
                <div className="indicator-value">
                    {data?.chf_eur?.rate ? `${data.chf_eur.rate} €` : 'N/A'}
                </div>
                {data?.chf_eur?.change && (
                    <div className="indicator-change">
                        <FormatChange change={data.chf_eur.change} />
                    </div>
                )}
            </div>
        </div>
    );
};

export default CurrencyRates;